import { useTranslation } from 'react-i18next';
import { OrgSortByEnum, type OrgSortBy } from 'src/types';

type Props = {
  handleClick: () => void;
  sortBy: OrgSortBy;
  setSortBy: (sortBy: OrgSortBy) => void;
};

export const SortItems = ({ handleClick, sortBy, setSortBy }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      {Object.values(OrgSortByEnum).map((sort, i) => (
        <button
          key={`sort-${i}`}
          className={`w-full whitespace-nowrap py-0.5 text-left transition-all ${
            sortBy === sort
              ? 'text-primary-dark hover:text-primary'
              : 'text-primary hover:text-primary-dark'
          }`}
          name={sort as keyof typeof OrgSortByEnum}
          onClick={(e) => {
            setSortBy(e.currentTarget.name as keyof typeof OrgSortByEnum);
            handleClick();
          }}
        >
          {t(`org_settings.sort.${sort}`)}
        </button>
      ))}
    </>
  );
};
